/* Fransk katalog for locale-commerce-preferences-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'pref.salesMode': 'Vue par défaut pour les nouvelles ventes',
  'pref.salesModeSub': 'S\'applique aux factures, devis, confirmations de commande, avoirs et autres ventes. Vous pouvez changer temporairement de vue dans le formulaire.',
  'pref.purchaseMode': 'Vue par défaut pour les nouveaux achats',
  'pref.purchaseModeSub': 'Choisissez si les nouveaux achats s\'ouvrent normalement pas à pas ou avec l\'ensemble du formulaire sur une seule page.',
  'pref.mode.firstChoiceHelp': 'Ce choix devient votre valeur par défaut. Vous pouvez changer de vue dans le formulaire ou modifier la valeur par défaut plus tard sous Paramètres → Préférences.',
  'pref.mode.saveFailed': 'La vue a été changée, mais la valeur par défaut n\'a pas pu être enregistrée. Réessayez sous Paramètres → Préférences.',
  'pref.mode.unsupported': 'Choix de vue non valide.',
});
